export default () => {
    return useCookie('accessToken', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
